import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CasaDeLaVillaflor from "../pages/casa-de-la-villaflor/page";
import CasaDeElGolfo from "../pages/casa-de-el-golfo/page";
import VillaBuenlugar from "../pages/villa-buenlugar/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/villa-buenlugar",
    element: <VillaBuenlugar />,
  },
  {
    path: "/casa-de-la-villaflor",
    element: <CasaDeLaVillaflor />,
  },
  {
    path: "/casa-de-el-golfo",
    element: <CasaDeElGolfo />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;